import React, { useEffect } from 'react'
import { CustomHeading } from 'components'
import { Images } from 'constants'

const AllSports = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const sportsGames = [
        { name: 'Cricket', thumbnail: Images.CRICKET },
        { name: 'Soccer', thumbnail: Images.SOCCER },
        { name: 'Tennis', thumbnail: Images.TENNIS },
        { name: 'Kabaddi', thumbnail: Images.KABADDI },
        { name: 'Cup Winner', thumbnail: Images.CUP_WINNER },
        { name: 'Politics', thumbnail: Images.POLITICS },
    ]

    return (
        <div className="p-1 flex justify-center items-center">
            <div>
                <CustomHeading
                    svg={false}
                    text="Sports Game"
                    down_icon={true}
                    redirect={false}
                    type={1}
                />

                <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 mt-2 mx-1">
                    {sportsGames.map((sport, index) => (
                        <div key={index}
                            className="rounded-lg w-full h-[100px] overflow-hidden shadow-md mx-auto"
                        >
                            <img
                                src={sport.thumbnail}
                                alt={`${sport.name} Thumbnail`}
                                className="w-full h-full object- rounded-lg"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default AllSports
